var angular = require('angular');
var app = angular.module('learn-directives');

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { ChakraProvider } from '@chakra-ui/react';
import Layout from '../../top-navigation/top-navigation-app';
import React from 'react';
import { createRoot } from 'react-dom/client';

// Create a single QueryClient instance outside the component
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const layoutProps = {
  user: null,
  company: null,
  initialOpen: false,
  accessHelper: null,
  urlLookup: null,
  application: null,
  authorization: null,
  analyze: null,
  zendeskWidget: null,
};

function renderLayout(root, layoutProps) {
  
  root.render(
    
    <QueryClientProvider client={queryClient}>
        <ChakraProvider>
        <Layout {...layoutProps} />
            </ChakraProvider>    
      
    
    </QueryClientProvider>
    
  );
}

const reactDirective = app.directive('topNavigationDirective', [
  'Application',
  'Authorization',
  'Analyze',
  'AccessHelper',
  'UrlLookup',
  'ZendeskWidget',
  '$translate',
  function (Application, Authorization, Analyze, AccessHelper, UrlLookup, ZendeskWidget, $translate) {
    return {
      template: '<div id="top-navigation-app" class="react-part">Top Navigation</div>',
      scope: {},
      link: function (scope, el, attrs) {
        const reactapp = document.getElementById('top-navigation-app');
        const root = createRoot(reactapp);

        // const self = this;
        const { company, user } = Authorization.getAuthToken();

        // Fallback english translations
        const translations = {
          userMenuNotifications: 'Notifications',
          editProfile: 'Edit Profile',
          peopleSearch: 'People Search',
          support: 'Support',
          whatsNew: "What's New",
          reviewUs: 'Review Us',
          qooper: 'Qooper',
          logout: 'Logout',
          notifications: 'Notifications',
          notificationsUnread: 'Unread',
          notificationsRead: 'Read',
          notificationsNoUnread: 'You have no unread notifications.'
        }

        layoutProps.user = user;
        layoutProps.company = company;
        layoutProps.accessHelper = AccessHelper;
        layoutProps.urlLookup = UrlLookup;  
        layoutProps.application = Application;
        layoutProps.authorization = Authorization;
        layoutProps.analyze = Analyze;
        layoutProps.zendeskWidget = ZendeskWidget;
        layoutProps.translations = translations;

        // Helper function to safely extract translated text
        const getTranslatedText = (key) => {
          const result = $translate.instant(key);
          
          if (typeof result === 'string') {
            return result;
          } else if (result && typeof result === 'object' && result.$$unwrapTrustedValue) {
            const unwrapped = result.$$unwrapTrustedValue();
            
            return unwrapped || key;
          }
          return key;
        };
        
        // Function to update translations and re-render
        const updateTranslations = () => {
          
          const readyTranslations = {
            userMenuNotifications: getTranslatedText('userMenu.notifications'),
            editProfile: getTranslatedText('userMenu.editProfile'),
            peopleSearch: getTranslatedText('userMenu.peopleSearch'),
            support: getTranslatedText('userMenu.support'),
            whatsNew: getTranslatedText('userMenu.whatsNew'),
            reviewUs: getTranslatedText('userMenu.reviewUs'),
            qooper: getTranslatedText('userMenu.qooper'),
            logout: getTranslatedText('userMenu.logout'),
            notifications: getTranslatedText('notifications'),
            notificationsUnread: getTranslatedText('notifications.unread'),
            notificationsRead: getTranslatedText('notifications.read'),
            notificationsNoUnread: getTranslatedText('notifications.noUnread'),
            supportMenuCaption: getTranslatedText(Application.ticketingBrand.caption),
            supportMenuLink: getTranslatedText(Application.ticketingBrand.link)
          };
          
          
          layoutProps.translations = readyTranslations;
          renderLayout(root, layoutProps);
        };

        // Wait for translation service to be ready, reset translations
        $translate.onReady(() => {
          
          updateTranslations();
        });
        
        // Watch for language changes by monitoring $translate.use()
        let currentLanguage = $translate.use();
        scope.$watch(() => $translate.use(), function(newLang, oldLang) {
          if (newLang !== oldLang && newLang) {

            // Add a small delay to ensure translations are loaded
            setTimeout(() => {
              updateTranslations();
            }, 100);
          }
        });
        
        // Also listen for the translate change success event as backup
        scope.$on('$translateChangeSuccess', function(event, data) {
          
          updateTranslations();
        });

        // We know these will all be populated by the time we get here as part of Application setup,
        //   so it's safe to render.
        renderLayout(root, layoutProps);

        scope.$watch(
          'authToken',
          function (newValue, oldValue) {
            if (angular.isDefined(newValue) && newValue !== oldValue) {
              layoutProps.authToken = newValue;
              renderLayout(root, layoutProps);
            }
          },
          true
        );
      },    
    };
  },
]);

export default reactDirective;
